export default function(_) {
  return _ == null || _ === '' ? null : !_ || _ === 'false' || _ === '0' ? false : !!_;
}



// WEBPACK FOOTER //
// ./~/vega-util/src/toBoolean.js